module.exports = __webpack_public_path__ + "static/media/bg3_xs.398711ac.webp";